import axios from '../../v2/app/services/axiosService';
import moment from 'moment-timezone';

export default {
  /**
   * MLD-4832
   * @param sessionUUID
   * @param elapsedMS
   * @returns {Promise<AxiosResponse<any>>}
   */
  async pingSession(sessionUUID, elapsedMS) {
    const form = {
      elapsed_ms: elapsedMS,
      ended_at: moment().unix(),
    }
    const response = await axios.put(`/api/device-sessions/${sessionUUID}/ping`, form);
    return response.data;
  }
}
